import { createContext, useContext } from 'react'
import { ActivityValue } from 'types/shared'

export type BlueprintTrigger = {
  type: 'initial' | 'activity_changed'
  activityValue?: ActivityValue
  activityModelUuid?: string
  parentPath?: string[]
}

type BlueprintsContextType = {
  isFetchingBlueprints?: boolean
  executeBlueprints: (trigger?: BlueprintTrigger) => void
}

export const BlueprintsContext = createContext<BlueprintsContextType>({
  isFetchingBlueprints: false,
  executeBlueprints: () => {}
})

export default function useBlueprintsContext() {
  return useContext(BlueprintsContext)
}
